import React from 'react';


const DashboardHome = () => {
    return (
        <section>
            <h1 className='text-center my-5'>Dashboard Home</h1>
            <h4 className='text-primary'>Coming soon...</h4>
        </section>
    );
};

export default DashboardHome;